/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

// eslint-disable-next-line prettier/prettier
import {
  ca,
  cs,
  de,
  enCA,
  enGB,
  enNZ,
  enUS,
  es,
  fr,
  frCA,
  frCH,
  gl,
  id,
  it,
  ja,
  ko,
  nl,
  pl,
  pt,
  ro,
  ta,
  te,
  th,
  zhCN,
  zhTW,
} from 'date-fns/locale';

import { LANGUAGES, LOCALES, REGIONS } from './types';

export const LOCALE_DATA = {
  [LOCALES.ca_es]: {
    code: LOCALES.ca_es,
    region: REGIONS.ES,
    language: LANGUAGES.ca,
    dateFormat: ca,
  },
  [LOCALES.cs_cz]: {
    code: LOCALES.cs_cz,
    region: REGIONS.CZ,
    language: LANGUAGES.cs,
    dateFormat: cs,
  },
  [LOCALES.de_ch]: {
    code: LOCALES.de_ch,
    region: REGIONS.CH,
    language: LANGUAGES.de,
    dateFormat: frCH,
  },
  [LOCALES.de_de]: {
    code: LOCALES.de_de,
    region: REGIONS.DE,
    language: LANGUAGES.de,
    dateFormat: de,
  },
  [LOCALES.de_aq]: {
    code: LOCALES.de_aq,
    region: REGIONS.AQ,
    language: LANGUAGES.de,
    dateFormat: de,
  },
  [LOCALES.de_at]: {
    code: LOCALES.de_at,
    region: REGIONS.AT,
    language: LANGUAGES.de,
    dateFormat: de,
  },
  [LOCALES.en_ca]: {
    code: LOCALES.en_ca,
    region: REGIONS.CA,
    language: LANGUAGES.en,
    dateFormat: enCA,
  },
  [LOCALES.en_ch]: {
    code: LOCALES.en_ch,
    region: REGIONS.CH,
    language: LANGUAGES.en,
    dateFormat: frCH,
  },
  [LOCALES.en_de]: {
    code: LOCALES.en_de,
    region: REGIONS.DE,
    language: LANGUAGES.en,
    dateFormat: de,
  },
  [LOCALES.en_gb]: {
    code: LOCALES.en_gb,
    region: REGIONS.GB,
    language: LANGUAGES.en,
    dateFormat: enGB,
  },
  [LOCALES.en_nz]: {
    code: LOCALES.en_nz,
    region: REGIONS.NZ,
    language: LANGUAGES.en,
    dateFormat: enNZ,
  },
  [LOCALES.en_us]: {
    code: LOCALES.en_us,
    region: REGIONS.US,
    language: LANGUAGES.en,
    dateFormat: enUS,
  },
  [LOCALES.en_za]: {
    code: LOCALES.en_za,
    region: REGIONS.ZA,
    language: LANGUAGES.en,
    dateFormat: enGB,
  },
  [LOCALES.en_es]: {
    code: LOCALES.en_es,
    region: REGIONS.ES,
    language: LANGUAGES.en,
    dateFormat: es,
  },
  [LOCALES.en_aq]: {
    code: LOCALES.en_aq,
    region: REGIONS.AQ,
    language: LANGUAGES.en,
    dateFormat: enUS,
  },
  [LOCALES.en_kr]: {
    code: LOCALES.en_kr,
    region: REGIONS.KR,
    language: LANGUAGES.en,
    dateFormat: ko,
  },
  [LOCALES.en_fr]: {
    code: LOCALES.en_fr,
    region: REGIONS.FR,
    language: LANGUAGES.en,
    dateFormat: fr,
  },
  [LOCALES.en_pt]: {
    code: LOCALES.en_pt,
    region: REGIONS.PT,
    language: LANGUAGES.en,
    dateFormat: pt,
  },
  [LOCALES.en_sg]: {
    code: LOCALES.en_sg,
    region: REGIONS.SG,
    language: LANGUAGES.en,
    dateFormat: enGB,
  },
  [LOCALES.en_cz]: {
    code: LOCALES.en_cz,
    region: REGIONS.CZ,
    language: LANGUAGES.en,
    dateFormat: cs,
  },
  [LOCALES.en_pl]: {
    code: LOCALES.en_pl,
    region: REGIONS.PL,
    language: LANGUAGES.en,
    dateFormat: pl,
  },
  [LOCALES.en_at]: {
    code: LOCALES.en_at,
    region: REGIONS.AT,
    language: LANGUAGES.en,
    dateFormat: enGB,
  },
  [LOCALES.en_ro]: {
    code: LOCALES.en_ro,
    region: REGIONS.RO,
    language: LANGUAGES.en,
    dateFormat: enGB,
  },
  [LOCALES.en_tw]: {
    code: LOCALES.en_tw,
    region: REGIONS.TW,
    language: LANGUAGES.en,
    dateFormat: enGB,
  },
  [LOCALES.en_my]: {
    code: LOCALES.en_my,
    region: REGIONS.MY,
    language: LANGUAGES.en,
    dateFormat: enGB,
  },
  [LOCALES.en_id]: {
    code: LOCALES.en_id,
    region: REGIONS.ID,
    language: LANGUAGES.en,
    dateFormat: enGB,
  },
  [LOCALES.en_th]: {
    code: LOCALES.en_th,
    region: REGIONS.TH,
    language: LANGUAGES.en,
    dateFormat: enGB,
  },
  [LOCALES.en_ja]: {
    code: LOCALES.en_ja,
    region: REGIONS.JP,
    language: LANGUAGES.en,
    dateFormat: enGB,
  },
  [LOCALES.es_es]: {
    code: LOCALES.es_es,
    region: REGIONS.ES,
    language: LANGUAGES.es,
    dateFormat: es,
  },
  [LOCALES.es_aq]: {
    code: LOCALES.es_aq,
    region: REGIONS.AQ,
    language: LANGUAGES.es,
    dateFormat: es,
  },
  [LOCALES.es_pt]: {
    code: LOCALES.es_pt,
    region: REGIONS.PT,
    language: LANGUAGES.es,
    dateFormat: es,
  },
  [LOCALES.eu_es]: {
    code: LOCALES.eu_es,
    region: REGIONS.ES,
    language: LANGUAGES.eu,
    dateFormat: es,
  },
  [LOCALES.fr_ca]: {
    code: LOCALES.fr_ca,
    region: REGIONS.CA,
    language: LANGUAGES.fr,
    dateFormat: frCA,
  },
  [LOCALES.fr_ch]: {
    code: LOCALES.fr_ch,
    region: REGIONS.CH,
    language: LANGUAGES.fr,
    dateFormat: frCH,
  },
  [LOCALES.fr_aq]: {
    code: LOCALES.fr_aq,
    region: REGIONS.AQ,
    language: LANGUAGES.fr,
    dateFormat: fr,
  },
  [LOCALES.fr_fr]: {
    code: LOCALES.fr_fr,
    region: REGIONS.FR,
    language: LANGUAGES.fr,
    dateFormat: fr,
  },
  [LOCALES.gl_es]: {
    code: LOCALES.gl_es,
    region: REGIONS.ES,
    language: LANGUAGES.gl,
    dateFormat: gl,
  },
  [LOCALES.hak_tw]: {
    code: LOCALES.hak_tw,
    region: REGIONS.TW,
    language: LANGUAGES.hak,
    dateFormat: zhTW,
  },
  [LOCALES.id_id]: {
    code: LOCALES.id_id,
    region: REGIONS.ID,
    language: LANGUAGES.id,
    dateFormat: id,
  },
  [LOCALES.it_ch]: {
    code: LOCALES.it_ch,
    region: REGIONS.CH,
    language: LANGUAGES.it,
    dateFormat: frCH,
  },
  [LOCALES.it_aq]: {
    code: LOCALES.it_aq,
    region: REGIONS.AQ,
    language: LANGUAGES.it,
    dateFormat: it,
  },
  [LOCALES.ja_ja]: {
    code: LOCALES.ja_ja,
    region: REGIONS.JP,
    language: LANGUAGES.ja,
    dateFormat: ja,
  },
  [LOCALES.jv_id]: {
    code: LOCALES.jv_id,
    region: REGIONS.ID,
    language: LANGUAGES.jv,
    dateFormat: id,
  },
  [LOCALES.ko_kr]: {
    code: LOCALES.ko_kr,
    region: REGIONS.KR,
    language: LANGUAGES.ko,
    dateFormat: ko,
  },
  [LOCALES.ml_my]: {
    code: LOCALES.ml_my,
    region: REGIONS.MY,
    language: LANGUAGES.ml,
    dateFormat: enGB,
  },
  [LOCALES.ms_sg]: {
    code: LOCALES.ms_sg,
    region: REGIONS.SG,
    language: LANGUAGES.ms,
    dateFormat: enGB,
  },
  [LOCALES.ms_my]: {
    code: LOCALES.ms_my,
    region: REGIONS.MY,
    language: LANGUAGES.ms,
    dateFormat: enGB,
  },
  [LOCALES.nan_tw]: {
    code: LOCALES.nan_tw,
    region: REGIONS.TW,
    language: LANGUAGES.nan,
    dateFormat: zhTW,
  },
  [LOCALES.nl_nl]: {
    code: LOCALES.nl_nl,
    region: REGIONS.NL,
    language: LANGUAGES.nl,
    dateFormat: nl,
  },
  [LOCALES.nl_id]: {
    code: LOCALES.nl_id,
    region: REGIONS.ID,
    language: LANGUAGES.nl,
    dateFormat: nl,
  },
  [LOCALES.pa_my]: {
    code: LOCALES.pa_my,
    region: REGIONS.MY,
    language: LANGUAGES.pa,
    dateFormat: enGB,
  },
  [LOCALES.pl_pl]: {
    code: LOCALES.pl_pl,
    region: REGIONS.PL,
    language: LANGUAGES.pl,
    dateFormat: pl,
  },
  [LOCALES.pt_es]: {
    code: LOCALES.pt_es,
    region: REGIONS.ES,
    language: LANGUAGES.pt,
    dateFormat: pt,
  },
  [LOCALES.pt_pt]: {
    code: LOCALES.pt_pt,
    region: REGIONS.PT,
    language: LANGUAGES.pt,
    dateFormat: pt,
  },
  [LOCALES.ro_ro]: {
    code: LOCALES.ro_ro,
    region: REGIONS.RO,
    language: LANGUAGES.ro,
    dateFormat: ro,
  },
  [LOCALES.ta_sg]: {
    code: LOCALES.ta_sg,
    region: REGIONS.SG,
    language: LANGUAGES.ta,
    dateFormat: ta,
  },
  [LOCALES.ta_my]: {
    code: LOCALES.ta_my,
    region: REGIONS.MY,
    language: LANGUAGES.ta,
    dateFormat: ta,
  },
  [LOCALES.te_my]: {
    code: LOCALES.te_my,
    region: REGIONS.MY,
    language: LANGUAGES.te,
    dateFormat: te,
  },
  [LOCALES.th_my]: {
    code: LOCALES.th_my,
    region: REGIONS.MY,
    language: LANGUAGES.th,
    dateFormat: th,
  },
  [LOCALES.th_th]: {
    code: LOCALES.th_th,
    region: REGIONS.TH,
    language: LANGUAGES.th,
    dateFormat: th,
  },
  [LOCALES.zh_sg]: {
    code: LOCALES.zh_sg,
    region: REGIONS.SG,
    language: LANGUAGES.zh,
    dateFormat: zhCN,
  },
  [LOCALES.zh_tw]: {
    code: LOCALES.zh_tw,
    region: REGIONS.TW,
    language: LANGUAGES.zh,
    dateFormat: zhTW,
  },
  [LOCALES.zh_my]: {
    code: LOCALES.zh_my,
    region: REGIONS.MY,
    language: LANGUAGES.zh,
    dateFormat: zhCN,
  },
};
